import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BlobChunkDto } from '../../../../models/ts/blob-chunk-dto.model';
import { MediaCommitDto } from '../../../../models/ts/media-commit-dto.model';
import { CollectionInstanceMetadata, MediaDto, MediaWithMeta } from '../../../../models/ts/media-dto.model';
import { RetrDocAccessType } from '../../../../models/ts/retr-doc-access-type.model';
import { IndexedDBService } from 'src/app/core/services/indexed-db/indexed-db.service';

@Injectable({
  providedIn: 'root',
})
export class MediaApiService {

  public constructor(
    private http: HttpClient,
    private indexedDbService: IndexedDBService,
  ) {

  }


  public downloadFile(collectionsId: number, instanceId: number, versionId: number): Observable<ArrayBuffer> {
    return this.http.get(
      `api/collection/${collectionsId}/instance/${instanceId}/version/${versionId}/file`, { responseType: 'arraybuffer' });
  }

  public downloadFileWithResponse(collectionsId: number, instanceId: number, versionId: number): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(
      `api/collection/${collectionsId}/instance/${instanceId}/version/${versionId}/file`, {
        responseType: 'arraybuffer',
        observe: 'response',
      });
  }

  public downloadPdfFileWithResponse(collectionsId: number, instanceId: number, versionId: number): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(
      `api/collection/${collectionsId}/instance/${instanceId}/version/${versionId}/pdffile`, {
        responseType: 'arraybuffer',
        observe: 'response',
      });
  }

  public getFileMeta(request: { collectionId: number, versionId: number }): Observable<CollectionInstanceMetadata> {
    return this.http.get<CollectionInstanceMetadata>(`api/collection/${request.collectionId}/version/${request.versionId}/filemetadata`);
  }

  public copyDirectLink(request: {
    CollectionsID: number,
    ID: number,
    VersionsID: number,
    RetrDocAccessType: RetrDocAccessType
  }): Observable<string> {
    return this.http.get(`api/collection/${request.CollectionsID}/instance/${request.ID}/version/${request.VersionsID}/accesstype/${request.RetrDocAccessType}/directlink`, { responseType: 'text' });
  }

  public downloadQRCodeDirectLink(request: {
    CollectionsID: number,
    ID: number,
    VersionsID: number,
    RetrDocAccessType: RetrDocAccessType
  }): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`api/collection/${request.CollectionsID}/instance/${request.ID}/version/${request.VersionsID}/accesstype/${request.RetrDocAccessType}/directlink/qrcode`, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  public downloadQRCodeToRecord(request: {
    CollectionsID: number,
    ID: number,
    VersionsID: number,
  }): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`api/collection/${request.CollectionsID}/instance/${request.ID}/version/${request.VersionsID}/qrcode`, {
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  public downloadMailFile(request: { mailId: number, mediasId: number, name: string }): Observable<ArrayBuffer> {
    return this.http.post(
      `api/mail/${request.mailId}/media/${request.mediasId}/download`, JSON.stringify(request.name), {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'arraybuffer',
      });
  }

  public uploadFileFromFormData(data: FormData): Observable<HttpEvent<BlobChunkDto>> {
    return this.http.post<BlobChunkDto>('api/media/upload', data, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public commitMailAttachment(data: MediaCommitDto): Observable<number> {
    return this.http.post<number>('api/collectionupload/commitmailattachment', data);
  }

  public getMediaList(request: { mediaIds: Array<number> }): Observable<Array<MediaDto>> {
    return this.http.post<Array<MediaDto>>('api/media/mediaIds', request.mediaIds);
  }

  public getMediaWithMeta(request: { mediaIds: Array<number> }): Observable<Array<MediaWithMeta>> {
    return this.http.post<Array<MediaWithMeta>>('api/media/mediaWithMeta', request.mediaIds);
  }
}
